"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BellIcon = void 0;
var react_1 = __importDefault(require("react"));
var BellIcon = function (props) { return (react_1.default.createElement("svg", __assign({ width: "30", height: "36", viewBox: "0 0 30 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("rect", { y: "18.5713", width: "30", height: "4.28571", fill: "black" }),
    react_1.default.createElement("path", { d: "M2.85742 11.4286C2.85742 5.11674 7.97417 0 14.286 0V0C20.5978 0 25.7146 5.11674 25.7146 11.4286V18.5714H2.85742V11.4286Z", fill: "black" }),
    react_1.default.createElement("circle", { cx: "14.2857", cy: "31.4285", r: "4.28571", fill: "#9B9B9B" }))); };
exports.BellIcon = BellIcon;
